export const updateListReferences = (array,object, idx) => {
  return [
    ...array.slice(0, idx),
    object,
    ...array.slice(idx + 1)
  ]
}
